import axios from "axios";
import axiosInstance from "@/services/https/global";
import CONFIG from "../config";

const baseUrl = `${CONFIG.BASE_URL}/audit-reporting/api/v1`;

// period: 7d | 14d | 30d | 60d | 90d (default 30d)
export const getPayoutStats = async (period = "30d") => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/stats/summary`, {
      params: { period },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getUserStats = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/stats/users`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

// period: 7d | 14d | 30d | 60d | 90d (default 30d)
export const getTrendStats = async (period = "30d") => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/stats/trend`, {
      params: { period },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

// period: 7d | 14d | 30d | 60d | 90d (default 30d), channel: optional channel filter
export const getChannelTrendStats = async (period = "30d", channel) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/stats/trend/channels`, {
      params: { period, channel },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

// period: 7d | 14d | 30d | 60d | 90d (default 30d)
export const getChannelStats = async (period = "30d") => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/stats/channels`, {
      params: { period },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

